exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nsvg[data-v-ec944b36] {\n  pointer-events: none;\n  position: fixed;\n  right: 0;\n}\nsvg polygon[data-v-ec944b36],\nsvg rect[data-v-ec944b36] {\n  pointer-events: auto;\n}\n", ""]);

